import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as CheckRegister } from "../../assets/icons/checkRegister.svg";
import { ReactComponent as Error } from "../../assets/icons/error.svg";
import { ReactComponent as PathfinderLogoLeftCorner } from "../../assets/images/Pathifnder Logo_White.svg";
import loginBackground from "../../assets/images/login-background.png";

import { Auth } from "../../routes/Constants";

import APIVariables from "../../services/api-variables";
import { errorMessages } from "../../constants/errorMessages.constants";
import Axios from "../../services/Axios";

const shellClass =
  "relative isolate flex min-h-screen min-h-dvh flex-col bg-[#0d5c52] bg-cover bg-center bg-fixed bg-no-repeat font-sans";
const cardClass =
  "login-z w-full max-w-[520px] rounded-[2.75rem] border border-white/30 bg-white/18 px-8 py-10 shadow-[0_8px_40px_rgba(0,0,0,0.18)] backdrop-blur-[22px] sm:px-12";
const cardStyle = { WebkitBackdropFilter: "blur(22px)" };
const greenButtonClass =
  "inline-flex h-[46px] min-w-[160px] cursor-pointer items-center justify-center rounded-full border-0 bg-[#00a03b] px-6 text-lg font-bold text-white hover:bg-[#008a32]";

const Validate = () => {
  const navigate = useNavigate();

  const [displayModal, setDisplayMessage] = useState(false);
  const [message, setMessage] = useState({
    title: "",
    description: "",
    isValid: true,
  });

  useEffect(() => {
    checkActivateAccount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function checkActivateAccount() {
    const uid = window.location.pathname.split("/")[2];
    const token = window.location.pathname.split("/")[3];

    const responseRegister = await Axios.post(APIVariables.USERS_ACTIVATE, {
      uid,
      token,
    }).catch((error) => {
      if (error?.response?.data?.uid?.includes("Activation link is invalid!")) {
        setDisplayMessage(true);
        setMessage({
          title: "Confirmation Link is Invalid",
          description:
            "Please click/copy the link again to confirm your email.",
          isValid: false,
        });
      } else {
        setDisplayMessage(true);
        setMessage({
          title: error?.response?.statusText,
          description: errorMessages.SOMETHING_WENT_WRONG,
          isValid: false,
        });
      }
    });
    if (responseRegister?.status === 200) {
      setDisplayMessage(true);
      setMessage({
        title: "Success",
        description: responseRegister?.data?.message,
        isValid: true,
      });
    }
  }

  function logIn() {
    navigate(Auth.LOGIN, { replace: true });
  }

  const shellStyle = { backgroundImage: `url(${loginBackground})` };

  return (
    <div
      className={shellClass}
      style={shellStyle}
      data-testid="auth-validate-page"
    >
      <header className="login-z flex shrink-0 items-center px-6 py-6 sm:px-10">
        <PathfinderLogoLeftCorner
          className="h-[34px] w-auto max-w-[min(100%,186px)] sm:h-[42px]"
          aria-label="PATHFINDER Connect"
          role="img"
        />
      </header>

      <main className="login-z flex flex-1 flex-col items-center justify-center px-4 pb-10 pt-2">
        <div
          className={cardClass}
          style={cardStyle}
          data-testid="auth-validate-card"
        >
          {!displayModal ? (
            <div
              className="flex min-h-[280px] flex-col items-center justify-center text-center text-white"
              data-testid="auth-validate-loading"
            >
              <p className="text-base text-white/90">
                Validating your account…
              </p>
            </div>
          ) : (
            <div
              className="flex min-h-[280px] flex-col items-center justify-center px-2 text-center"
              data-testid="auth-validate-result"
            >
              <div className="mb-2.5 flex justify-center">
                {message.isValid ? (
                  <CheckRegister className="h-20 w-20" aria-hidden />
                ) : (
                  <Error className="h-20 w-20" aria-hidden />
                )}
              </div>
              <h1
                className={
                  message.isValid
                    ? "mb-2.5 text-[30px] font-bold leading-[37px] text-[#3c3c3c]"
                    : "mb-2.5 text-[30px] font-bold leading-[37px] text-[#da291c]"
                }
                data-testid="auth-validate-heading"
              >
                {message.title}
              </h1>
              <p
                className="py-2.5 text-base leading-5 text-[#646464]"
                data-testid="auth-validate-description"
              >
                {message.description}
              </p>
              {message.isValid && (
                <button
                  type="button"
                  className={`${greenButtonClass} mt-6`}
                  onClick={logIn}
                  data-testid="auth-validate-login-button"
                >
                  Login
                </button>
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Validate;
